"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonSpecType_1 = require("../../models/ComparisonSpecType");
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
var RowShift_1 = require("../../transforms/table/RowShift");
var TimeShift_1 = require("../../transforms/table/TimeShift");
var metricValue_1 = require("../metricValue");
var threshold_1 = require("../threshold");
var defaults_1 = require("./defaults");
exports.COMPARISON_TIMESTAMP_COLUMN_NAME = defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME;
exports.COMPARISON_MEASURE_COLUMN_NAME = defaults_1.COMPARISON_MEASURE_COLUMN_NAME;
var DEFAULT_COMPARISON_NAME = 'comparison';
exports.defaultComparisonSchema = function (timestampColumnRef, measureColumnRef) {
    var _a;
    return _a = {},
        _a[defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME] = {
            type: EffectiveDefinition_1.DateTimeType,
            name: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
            calculation: {
                type: EffectiveDefinition_1.TableCalcType,
                name: DEFAULT_COMPARISON_NAME,
                source: timestampColumnRef,
            },
        },
        _a[defaults_1.COMPARISON_MEASURE_COLUMN_NAME] = {
            type: EffectiveDefinition_1.NumberType,
            name: defaults_1.COMPARISON_MEASURE_COLUMN_NAME,
            calculation: {
                type: EffectiveDefinition_1.TableCalcType,
                name: DEFAULT_COMPARISON_NAME,
                source: measureColumnRef,
            },
        },
        _a;
};
exports.definitionWithComparison = function (definition, comparison, hideThresholdLine) {
    var comparisonName = 'comparison';
    if (ComparisonSpecType_1.isStaticComparison(comparison)) {
        return threshold_1.definitionWithStaticTarget(definition, comparison.value);
    }
    var newFeatures = makeFeaturesWithComparison(hideThresholdLine, comparison, definition);
    var newSchema = makeSchemaWithComparison(definition, comparison, comparisonName);
    var newTransforms = makeTableTransformWithComparison(comparison, definition, comparisonName);
    return __assign(__assign({}, definition), { features: newFeatures, schema: newSchema, tableTransforms: newTransforms });
};
var makeFeaturesWithComparison = function (hideThresholdLine, comparison, definition) {
    if (ComparisonSpecType_1.isNoComparison(comparison)) {
        // No comparison was set so remove the existing thresholds
        return __assign(__assign({}, definition.features), { threshold: {} });
    }
    // For now, we're swapping a new threshold if one already exists because we can (at the moment) only
    // have one threshold applied to a metric
    var newThresholdLine = {
        measure: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME },
        timestamp: { column: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
        style: __assign(__assign({}, threshold_1.defaultThresholdLineStyle()), { hidden: hideThresholdLine }),
    };
    var newThreshold = {
        thresholds: [
            {
                lines: [newThresholdLine],
            },
        ],
    };
    var newFeatures = __assign(__assign({}, definition.features), { threshold: newThreshold });
    return newFeatures;
};
var makeSchemaWithComparison = function (definition, comparison, comparisonName) {
    var _a;
    if (ComparisonSpecType_1.isNoComparison(comparison)) {
        // No comparison was set so don't modify the schema
        return __assign({}, definition.schema);
    }
    return __assign(__assign({}, definition.schema), (_a = {}, _a[defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME] = {
        type: EffectiveDefinition_1.DateTimeType,
        name: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        calculation: {
            type: EffectiveDefinition_1.TableCalcType,
            name: comparisonName,
            source: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        },
    }, _a[defaults_1.COMPARISON_MEASURE_COLUMN_NAME] = {
        type: EffectiveDefinition_1.NumberType,
        name: defaults_1.COMPARISON_MEASURE_COLUMN_NAME,
        calculation: {
            type: EffectiveDefinition_1.TableCalcType,
            name: comparisonName,
            source: { column: metricValue_1.MEASURE_COLUMN_NAME },
        },
    }, _a));
};
var makeTableTransformWithComparison = function (comparison, definition, comparisonName) {
    var _a;
    if (ComparisonSpecType_1.isNoComparison(comparison)) {
        // No comparison was set so remove the existing comparison if it exists
        var transformsWithNoComparison = __assign({}, definition.tableTransforms);
        delete transformsWithNoComparison[comparisonName];
        return transformsWithNoComparison;
    }
    var transform = tableTransformForComparison(comparison);
    var newTransforms = __assign(__assign({}, definition.tableTransforms), (_a = {}, _a[comparisonName] = transform, _a));
    return newTransforms;
};
var tableTransformForComparison = function (comparison) {
    if (ComparisonSpecType_1.isHistoricalComparisonSpec(comparison)) {
        return {
            type: TimeShift_1.TimeShiftType,
            source: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
            unit: comparison.comparisonPeriod,
            amount: comparison.numberOfPeriods,
        };
    }
    else if (ComparisonSpecType_1.isMarkBasedComparison(comparison)) {
        return {
            type: RowShift_1.RowShiftType,
            amount: comparison.numberOfMarks,
        };
    }
    else {
        return {};
    }
};
//# sourceMappingURL=index.js.map